/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// Combo Box Default
export const NONE_SELECTED = 'none selected';

// Shipping Method Selections
export const EXPEDITED = 'expedited';
export const EXPEDITED_PRICE = 1500000;
export const STANDARD = 'standard';
export const STANDARD_PRICE = 500000;

// Content Types
export const KNOW_BEFORE_YOU_GO = 'know-before-you-go';

// Pass Types
export const ANNUAL = 'ANNUAL';
export const MILITARY = 'MILITARY';
export const ACCESS = 'ACCESS';
export const SENIOR = 'SENIOR';

// Pass Images
// const PASS_IMG_PREFIX = `${process.env.CDN}/img/pass/`;
export const PASS_IMG_PREFIX = `${process.env.CDN}/img/pass/`;
export const ANNUAL_PASS_IMAGE = `${PASS_IMG_PREFIX}/annual_pass.png`;
export const FOURTH_GRADE_PASS_IMAGE = `${PASS_IMG_PREFIX}fourth_grade_pass.png`;
export const SENIOR_LIFETIME_PASS_IMAGE = `${PASS_IMG_PREFIX}senior_lifetime_pass.png`;
export const SENIOR_ANNUAL_PASS_IMAGE = `${PASS_IMG_PREFIX}senior_annual_pass.png`;
export const VOLUNTEER_PASS_IMAGE = `${PASS_IMG_PREFIX}volunteer_pass.png`;
export const MILITARY_PASS_IMAGE = `${PASS_IMG_PREFIX}military_pass.png`;
export const ACCESS_PASS_IMAGE = `${PASS_IMG_PREFIX}access_pass.png`;

// Pass Type IDs
export const ANNUAL_PASS_ID = '7005cd6e-8386-458e-b4b1-8b382bf70889';
export const MILITARY_PASS_ID = '7505cd6e-8386-458e-b4b1-8b382bf70889';
export const ACCESS_PASS_ID = '7305cd6e-8386-458e-b4b1-8b382bf70889';
export const SENIOR_PASS_ID = '7205cd6e-8386-458e-b4b1-8b382bf70889';

export const ROUTE_PREFIX = '/pass/';
export const PASS_PREFIX = 'PASS_';
export const PRICE_MAGNITUDE = 100000;
export const INTERAGENCY_ANNUAL_PASS_REDESIGN_FLAG = 'interagencyAnnualPassRedesign';
export const DATE_FORMAT = 'ddd, ll';
export const RESERVATIONS_ACTION_INSERT = 'insert';
export const RESERVATIONS_ACTION_UPDATE = 'update';

export const ReservationPointsOfSale = ['web', 'field', 'call-center'];
export const ReservationStatuses = ['pending', 'deleted', 'completed'];
